import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import styles from './style/index.less';
export var FormItem = function (props) {
    var View = useComponents().View;
    var label = props.label, children = props.children, _a = props.requiredMark, requiredMark = _a === void 0 ? false : _a;
    return (React.createElement(View, { className: styles['form-item'] },
        React.createElement(View, { className: "" + styles['form-item-container'] },
            label && React.createElement(View, { className: styles['form-item-label'] + " " + (requiredMark && styles['label-mark']) }, label),
            React.createElement(View, { className: styles['form-item-content'] }, children))));
};
